export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/personal_stylists.a8bb422.svg";